import { request } from "../core/request";
import { withBody } from "../utils/withBody";
import merge from "lodash/merge";

export function post(
  uri: string,
  body?: Record<string, string | number | boolean | undefined | string[] | number[]> | FormData | Object,
  options?: RequestInit,
) {
  if (!options) {
    options = {};
  }
  options.method = "POST";
  if (body) {
    withBody(body, options);
  }
  return request(uri, options);
}

export function postFile(uri: string, file: File | Blob, fileName?: string, options?: RequestInit) {
  const body = new FormData();
  body.append("file", file as Blob, fileName);
  const nextOptions = merge({
    headers: {
      'Content-type': '',
      'Accept': '*/*',
    }
  }, options);
  return post(uri, body, nextOptions);
}
